
import "bootstrap/dist/css/bootstrap.min.css";
import '../styles/globals.css';

import '../styles/styles.css';

import Layout from './layout';

import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  ApolloProvider, 
} from "@apollo/client";

import { CartProvider } from "../components/providers/CartProvider";

import React from 'react';
import * as ReactDOM from 'react-dom/client';
import { useEffect } from "react";

import {APISERVER} from "../services/globals";


const link = createHttpLink({
  uri: APISERVER,
  credentials: 'include'
});

const _client = new ApolloClient({
  cache: new InMemoryCache(),
  link
});


// _app.js
const MyApp = ({ Component, pageProps }) => {
  useEffect(() => {
    import("bootstrap/dist/js/bootstrap");
    import("bootstrap-icons/font/bootstrap-icons.css");
  }, []);
  // console.log("_app.js loaded, client:", _client);
  return (
              <CartProvider client={_client}>
              <ApolloProvider client={_client}>
              <Layout>
                 <Component {...pageProps} />
              </Layout>
              </ApolloProvider>
              </CartProvider>
  )
}
export default MyApp




